module.exports = __webpack_public_path__ + "113f90f02091572e677aa73beed96ba4.svg";